<mat-icon matTooltip="Check Status" (click)="navigateToTaskDetailsView($event)">
    open_in_browser</mat-icon>